import { axiosInstance } from '@/service/axios';

import { LocalStorage, LocalStorageItems } from './LocalStorage';

interface RegistrationResponse {
	access_token: string;
	specific_soi_flow?: boolean;
	user?: { email?: string };
}

export async function handleRegistrationRedirect(
	data: RegistrationResponse
): Promise<void> {
	const redirectUrl = import.meta.env.VITE_REDIRECT_URL;

	if (data.specific_soi_flow) {
		try {
			await axiosInstance.get(
				`auth/member/lender-login?token=${data.access_token}`
			);
			window.location.href = `${redirectUrl}?accessToken=${data.access_token}`;
			return;
		} catch {
			// fall through to default redirect
		}
	}

	const lander_id = LocalStorage.getItem(LocalStorageItems.LanderId);

	if (!lander_id?.includes('_typed_email')) {
		LocalStorage.setItem(LocalStorageItems.AccessToken, data.access_token);
		window.location.href = `${redirectUrl}?accessToken=${data.access_token}`;
		return;
	}

	LocalStorage.setItem(LocalStorageItems.Email, data.user?.email);
	window.location.href = `${redirectUrl}/email-verification?email=${data.user?.email}`;
}
